module.exports = __webpack_public_path__ + "img/undraw_fitting_pieces_cli3.b53a307f.svg";